import { InboxWorkspace } from "./InboxWorkspace";

/** The course inbox renders all work through the shared boxes. */
export function CourseInbox() { return <InboxWorkspace />; }
